<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteProductConfirm(form)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group(v-if="!isAdd")
          vm-input(:placeholder='$t("products.sku_placeholder")' :danger="!$v.form.sku" :danger-text="'Name must have at least 4 ' + $v.form.sku.$params.minLength + ' letters.'" v-model="form.sku" :label='$t("products.sku")' disabled)
        b-form-group
          vm-input(:placeholder='$t("products.name_placeholder")' v-model="form.name" :label='$t("products.name")' required)
        b-form-group
          vm-input(:placeholder='$t("products.description_placeholder")' v-model="form.description" :label='$t("products.description")' required)
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("products.number_part_placeholder")' v-model="form.number_part" :label='$t("products.number_part")' required)
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("products.price_placeholder")' v-model="form.price" :label='$t("products.price")' required type="number")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-typeahead(url="product_categories" :label='$t("products.product_category_id")' :serializer="item => item.name" :data="productsCatalog.productCategories" :placeholder="$t('products.product_category_id_placeholder')" :danger="!$v.form.product_category_id.numeric" :danger-text="$t('validation.required', { attribute: $t('products.product_category_id') })" v-model="form.product_category_id" :filter="query => `?param=*${query}*,name`" @input-change="autoCompleteFunc" :defaultValue="form.product_category_id && form.product_category ? form.product_category.name : ''")
            template(slot-scope="{data}")
              vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data.id" v-bind:text="item.text" v-for="item,index in data")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-typeahead(url="units_measurement" :label='$t("products.unit_measurement_id")' :serializer="item => item.name" :data="productsCatalog.unitsMeasurement" :placeholder='$t("products.unit_measurement_placeholder")' :danger="!$v.form.unit_measurement_id.numeric" :danger-text="$t('validation.required', { attribute: $t('products.unit_measurement_id') })" v-model="form.unit_measurement_id" :filter="query => `?param=*${query}*,name`" @input-change="autoCompleteFunc" :defaultValue="form.unit_measurement_id && form.unit_measurement ? form.unit_measurement.name : ''")
            template(slot-scope="{data}")
              vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data.id" v-bind:text="item.text" v-for="item,index in data")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(url="currencies" column="code" :placeholder='$t("products.currency_id_placeholder")' :danger="!$v.form.currency_id.numeric" :danger-text="'Name must have at least 4 ' + $v.form.currency_id.$params.numeric + ' letters.'" v-model="form.currency_id" :label='$t("products.currency_id")')
            vm-select-item(:key="index" :value="item.id" :text="item.code" v-for="(item,index) in productsCatalog.currencies")
      vm-col(vm-justify="center", vm-align="center", vm-w=12 v-if="isAdd")
        b-form-group
          span {{ $t("products.tech_sheet") }}
          input(type="file", ref="tech_sheet", v-on:change="handleTechUpload()", accept="application/msword, image/jpeg, image/x-png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document")
      vm-col(vm-justify="center", vm-align="center", vm-w=12 v-if="isAdd")
        b-form-group
          span {{ $t("products.security_sheet") }}
          input(type="file", ref="security_sheet", v-on:change="handleSegurityUpload()", accept="application/msword, image/jpeg, image/x-png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document")
</template>

<script>
import { required, numeric } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Products')

export default {
  name: 'ModalProducts',
  props: {
    form: {
      default: () => [],
      type: Object
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  data: () => ({
    tech_sheet: '',
    security_sheet: ''
  }),
  validations: {
    form: {
      sku: {
      },
      name: {
        required
      },
      description: {
        required
      },
      number_part: {
        required
      },
      price: {
        required
      },
      product_category_id: {
        numeric,
        required
      },
      unit_measurement_id: {
        numeric,
        required
      },
      currency_id: {
        numeric,
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalVisible',
      'productsCatalog'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('products.add') : this.$t('products.edit')
    }
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addProduct',
      'editProduct',
      'deleteProduct',
      'setModalVisible',
      'setModalCategoryVisible',
      'loadCatalog'
    ]),
    handleTechUpload () {
      this.tech_sheet = this.$refs.tech_sheet.files[0]
    },
    handleSegurityUpload () {
      this.security_sheet = this.$refs.security_sheet.files[0]
    },
    saveRecord () {
      this.isAdd ? this.addProduct({
        form: this.form,
        tech_sheet: this.tech_sheet,
        security_sheet: this.security_sheet
      }) : this.editProduct({
        form: this.form,
        tech_sheet: this.tech_sheet,
        security_sheet: this.security_sheet
      })
    },
    async deleteProductConfirm (product) {
      let t = this
      this.auxDeleteProduct = () => {
        t.deleteProduct(product)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { attribute: this.$t(product.sku) }),
        accept: this.auxDeleteProduct
      })
    },
    async getCatalog () {
      Object.keys(this.productsCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
</style>
